<template>
    <div>
        <div class="container">
            <div class="row">
                <div :class="[ 'col-12', 'metodics-title', {'visible' : visible}]" @click="toggle">
                    <span><span>{{ $t('study_metodic') }}</span></span>
                </div>
            </div>
        </div><!-- /.container -->
        <div v-if="visible" class="container-fluid metodics-blue-bg metodics-blue-bg-top-shadow mt-5">
            <div class="container pt-5">
                <div class="row">
                    <div class="col-12 metodics-desc">
                        Занятия проводятся по принципу «One person – one language». Педагог не использует родную речь.
                        <span class="strong-black">Иностранный язык на занятии – это единственное средство коммуникации.</span>
                        Свою речь педагог сопровождает мимикой, жестами, картинками.
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
        <div v-if="visible" class="container-fluid metodics-blue-bg">
            <div class="container">
                <div class="row">
                    <div class="col-12 metodics-title2 my-4">
                        {{ $t('study_metodic_consists') }}:
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
        <div v-if="visible" class="container-fluid metodics-blue-bg">
            <div class="container">
                <div class="row metodics-title-table d-lg-flex d-none">
                    <div class="col-4">
                        Навык:
                    </div>
                    <div class="col-4">
                        Цель:
                    </div>
                    <div class="col-4">
                        Результат:
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-2 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
        <div v-if="visible" class="container-fluid metodics-blue-bg-lg metodics-item-first">
            <div class="container">
                <div class="row metodics-item">
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4">
                        <div class="metodics-item-title">Коммуникативный подход</div>
                        <div class="metodics-item-subtitle">(Communicative language teaching)</div>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Цель:</div>
                        Помочь детям начать разговаривать на иностранном языке, <span class="strong-black">преодолеть языковой барьер</span>.
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Результат:</div>
                        Достигается путем <span class="strong-black">вовлечения</span> (engagement), <span
                            class="strong-black">изучения</span> (study), <span
                            class="strong-black">использования</span> (activation).
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-4 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->

        <div v-if="visible" class="container-fluid metodics-blue-bg-lg">
            <div class="container">
                <div class="row metodics-item">
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4">
                        <div class="metodics-item-title">Погружение в язык</div>
                        <div class="metodics-item-subtitle">(Language immersion)</div>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Цель:</div>
                        <span class="strong-black">Активировать</span> левое и правое полушарие мозга, <span
                            class="strong-black">ускорить</span> изучение иностранного языка.
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Результат:</div>
                        Благодаря использованию элементов погружения в язык мы <span class="strong-black">развиваем искусственный билингвизм</span>
                        у учеников.
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-4 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->

        <div v-if="visible" class="container-fluid metodics-blue-bg-lg">
            <div class="container">
                <div class="row metodics-item">
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4">
                        <div class="metodics-item-title">Метод физического реагирования</div>
                        <div class="metodics-item-subtitle">(Total Physical Response)</div>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Цель:</div>
                        <span class="strong-black">Донести</span> необходимый <span
                            class="strong-black">объем знаний</span> через три основных канала восприятия: визуальный,
                        аудиальный, кинестетический.
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Результат:</div>
                        <span class="strong-black">Понимание</span> иностранной речи. <span class="strong-black">Расширение</span>
                        словарного запаса. <span class="strong-black">Снятие</span> языкового барьера.
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-4 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->

        <div v-if="visible" class="container-fluid metodics-blue-bg-lg">
            <div class="container">
                <div class="row metodics-item">
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4">
                        <div class="metodics-item-title">Обучение чтению и письму</div>
                        <div class="metodics-item-subtitle">(Developing Reading and Writing)</div>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Цель:</div>
                        <span class="strong-black">Развить</span> у детей старше четырех лет <span class="strong-black">навык чтения и письма</span>
                        на иностранном языке.
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Результат:</div>
                        Ребенок <span class="strong-black">читает</span> иностранные тексты и <span
                            class="strong-black">понимает</span> их, умеет формулировать предложения и <span
                            class="strong-black">писать без ошибок</span>.
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-4 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->


        <div v-if="visible" class="container-fluid metodics-blue-bg-lg">
            <div class="container">
                <div class="row metodics-item">
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4">
                        <div class="metodics-item-title">Традиционная методика</div>
                        <div class="metodics-item-subtitle">(Traditional Approach)</div>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Цель:</div>
                        Изучить буквы, слоги, звуки, слова вне контекста, грамматику и синтаксис. Обучить чтению и
                        пересказу. <span class="strong-black">Традиционная методика адаптирована для достижения наших целей.</span>
                    </div>
                    <div class="col-12 col-lg-4 metodics-item-text">
                        <div class="d-lg-none d-block metodics-item-text-title mt-3">Результат:</div>
                        <span class="strong-black">Эффективная подготовка детей к школе</span>, научить выполнять
                        задания по школьным программам, развить навыки аудирования.
                    </div>
                </div>
                <div class="row d-lg-flex d-none">
                    <div class="col-12 mt-4 mb-4">
                        <div class="metodics-delimeter"></div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->


        <div v-if="visible" class="container-fluid metodics-blue-bg metodics-blue-bg-footer">
            <div class="container">
                <div class="row metodics-footer">
                    <div class="col-12 my-5">
                        Методика обучения детей иностранным языкам в Полиглотиках основывается на комбинации
                        классических и инновационных подходов обучения.
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
    </div>
</template>

<script>

    export default {
        name: 'CourseMetodics',

        data() {
            return {
                visible: true,
            }
        },

        methods: {
            toggle() {
                this.visible = !this.visible
            }
        },
    }
</script>

<style scoped>

    .metodics-footer {
        font-family: "Manrope Bold";
        color: #5ab947;
        font-size: 24px;
    }

    .metodics-item-text-title {
        font-family: "Manrope Bold";
        color: #5ab947;
    }

    .metodics-item-text {
        font-size: 15px;
        color: #4f4d5c;
        line-height: 18px;
    }

    .metodics-item-title {
        color: #ed1c24;
        font-size: 18px;
        font-family: "Manrope Bold";
    }

    .metodics-item-subtitle {
        color: #8b8496;
        font-size: 15px;
    }

    .metodics-delimeter {
        height: 1px;
        width: 100%;
        background-color: #d7e1e5;
    }

    .metodics-title-table {
        font-size: 18px;
        font-family: "Manrope Bold";
        color: #5ab947;
    }

    .metodics-title2 {
        font-size: 24px;
        font-family: "Manrope Bold";
        color: #231c37;
    }

    .metodics-desc {
        font-size: 18px;
    }

    .metodics-blue-bg-top-shadow {
        box-shadow: 6px 7px 7px 3px #00000082;
    }

    .metodics-blue-bg {
        background-color: #e6eff2;
    }

    .metodics-title {
        font-family: "Manrope Bold";
        font-size: 36px;
        color: #5ab947;
        position: relative;
    }

    .metodics-title > span > span {
        cursor: pointer;
        border-bottom: 2px dashed rgba(90, 185, 71, 0.61);
        position: relative;
    }

    .metodics-title > span > span::after {
        background-image: url('~@/assets/poliglotiki/images/metod-down.png');
        display: block;
        content: ' ';
        height: 9px;
        width: 18px;
        position: absolute;
        right: -22px;
        top: 49%;
    }

    .metodics-title.visible > span > span::after {
        background-image: url('~@/assets/poliglotiki/images/metod-up.png');
    }

    @media (min-width: 992px) {
        .metodics-blue-bg-lg {
            background-color: #e6eff2;
        }
    }

    @media (max-width: 991.8px) {
        .metodics-blue-bg-lg {
            box-shadow: 0px 5px 4px -2px #0000002b;
        }

        .metodics-blue-bg-footer, .metodics-item-first {
            box-shadow: inset 0px 5px 4px -2px #0000002b;
        }

        .metodics-item {
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom: 40px;
        }

        .metodics-desc, .metodics-title2, .metodics-title, .metodics-footer .col-12 {
            padding-left: 35px;
            padding-right: 35px;
        }
    }
</style>
